function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import my_access_service from '@/apps/data-platform/services/tables_views/my_access_service';
import tables_service from '@/apps/data-platform/services/tables_views/tables_service';
import assignments_service from '@/apps/data-platform/services/tables_views/assignments_service';
import { textsDefaul, envConfig, TAG_QUERIES, DEFAULT_TPL_FIELDS, UI_CUSTOM_PERMISIONS, TYPE_CHANGE_METADA, ROLES_LIST, ALL_TABLES_OPTION } from '@/js/constants';
import utils from '@/js/utils';
import tasks from '@/js/tasks';
import ProfilingExecuteItem from '@/components/profiling/ProfilingExecuteItem';
import ModalProfilingRules from '@/views/profiling/ModalProfilingRules';
import HistoryItem from '@/views/profiling/HistoryItem';
import ModalAccess from '@/components/ModalAccess';
import PaginationBasic from '@/components/PaginationBasic.vue';
import PaginationVue from '@/components/PaginationVue.vue';
import DialogsComponent from '@/components/DialogsComponent.vue';
import FormMetadataTableComponent from '../../../components/FormMetadataTableComponent.vue';
import PaginationFirestore from '@/components/PaginationFirestore.vue';
import StateComponent from '@/components/StateComponent.vue';
import { mapState } from 'vuex';
import FormAssignTemporalOwner from '@/components/FormAssignTemporalOwner.vue';
export default {
  name: 'ContMyTablesComponent',
  components: {
    ProfilingExecuteItem: ProfilingExecuteItem,
    ModalProfilingRules: ModalProfilingRules,
    HistoryItem: HistoryItem,
    ModalAccess: ModalAccess,
    PaginationBasic: PaginationBasic,
    PaginationVue: PaginationVue,
    DialogsComponent: DialogsComponent,
    FormMetadataTableComponent: FormMetadataTableComponent,
    PaginationFirestore: PaginationFirestore,
    StateComponent: StateComponent,
    FormAssignTemporalOwner: FormAssignTemporalOwner
  },
  data: function data() {
    return {
      MODAL_NAME_METADATA: 'ContTablesMeMetadata',
      MODAL_NAME_OWNER: 'ContTablesMeOwner',
      MODAL_NAME_ALL_OWNER: 'ContTablesMeOwnerAll',
      MODAL_NAME_METADATA_VIEW: 'ListObjectsSearchMetadataView',
      MODAL_NAME_PROFILING_VIEW: 'ContTableProfiling',
      MODAL_CONFIRM_EXECUTE_PROFILING: 'MODAL_CONFIRM_EXECUTE_PROFILING',
      MODAL_PROFILING_RULES: 'MODAL_PROFILING_RULES',
      MODAL_LIST_ACCESS: 'MODAL_LIST_ACCESS',
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      collapse_filter: false,
      queryResponse: {
        tables: []
      },
      searchOwnTables: '',
      tplToUpdate: {},
      PAGE_SIZE: envConfig.pagintaionSize,
      PAGE_TAGS_SIZE: envConfig.pagintaionTagsSize,
      Q_DEFAULT: TAG_QUERIES.MY_TABLES.replace('${email}', window.userInfo.email),
      messageEmptyList: textsDefaul.LOADING,
      filter: '',
      filterOn: [],
      paramsSearch: {},
      isNewQuery: true,
      defaultDomain: window.userInfo.domain,
      currentEmail: window.userInfo.email.toLowerCase(),
      listAccessTables: {},
      userHasPermission: false,
      title_modal: '',
      data_ds: null,
      path_name: '',
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      response_text: '',
      limit: envConfig.pagintaionSize,
      tableExecute: Object,
      item: Object,
      tableReference: Object,
      paginationObj: {
        offset: 0
      },
      pagination: {
        current: 1,
        limit: envConfig.pagintaionSize,
        total: 0,
        cursors: [null],
        next: false
      },
      nextToken: {},
      loadingPage: false,
      key_pagination: 1,
      key_table: 1,
      // For VIEWER_ONLY mode with lazy loading
      lazyLoadParamsForViewer: null
    };
  },
  props: {
    showDomains: {
      type: Boolean,
      required: false,
      default: true
    },
    approvalFlow: {
      type: Boolean,
      required: false,
      default: false
    },
    filter_enabled: {
      type: Boolean
    },
    source: {
      type: String,
      required: false,
      default: "bigquery"
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs'])), {}, {
    tableFields: function tableFields() {
      return [
      //{ key: '↕', variant: 'return-sort', class: 'w-2' },
      {
        text: this.traductor('my_objects.tablas_objects.table'),
        value: 'tableReference_tableId',
        sortable: true,
        class: 'text-left w-30'
      }, {
        text: this.traductor('my_objects.tablas_objects.environment'),
        value: "defaultFields.".concat(DEFAULT_TPL_FIELDS.ENVIRONMENT.name, ".enumValue.displayName"),
        class: 'w-10',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.columns'),
        value: 'schema_fields_length',
        class: 'w-8',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.rows'),
        value: 'numRows',
        class: 'w-5',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.creation_date'),
        value: 'creationTime',
        class: 'w-15',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.actions'),
        value: 'actions',
        class: 'text-left w-20',
        align: 'left'
      }];
    },
    no_tables: function no_tables() {
      return this.traductor('frases.no_tables');
    },
    isEmptyTable: function isEmptyTable() {
      return !(this.queryResponse && this.queryResponse.tables && this.queryResponse.tables.length);
    },
    hideAssignAllTables: function hideAssignAllTables() {
      var _this = this;
      var list_env = [];
      var data = {};
      if (this.queryResponse && this.queryResponse.tables && this.queryResponse.tables.length && !this.approvalFlow) {
        var _iterator = _createForOfIteratorHelper(this.queryResponse.tables),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var table = _step.value;
            data = {
              env: table.defaultFields.env.enumValue.displayName,
              operator: table.defaultFields.operator.stringValue
            };
            list_env.push(data);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return list_env.some(function (item) {
        return item.env === 'prod' && _this.toLower(item.operator) === _this.currentEmail;
      });
    },
    hasDataQualityPermission: function hasDataQualityPermission() {
      return utils.hasRole(ROLES_LIST.DATAQUALITY_OPERATOR) || utils.hasRole(ROLES_LIST.ORG_DATA_STEWARD);
    },
    rows: function rows() {
      return (this.queryResponse.tables || []).length;
    }
  }),
  created: function created() {
    /*if (window.userInfo.isSignIn) {
      window.userInfo.isSignIn = false
      setTimeout(() => {
        location.reload()
      }, 500)
    }
    if (window.userInfo.isSignIn === undefined) {
      this.reloadList()
    }*/
    this.fetchPage(true);
    this.userHasPermission = this.hasPermission();
    console.log("source_acc", this.projects);
    console.log("query", this.queryResponse);
  },
  methods: {
    onSearch: function onSearch(filter) {
      this.filter = filter.text_filter;
      this.defaultDomain = filter.choose_domain;
      this.fetchPage(true);
    },
    onCleanSearch: function onCleanSearch() {
      this.filter = '';
      this.defaultDomain = window.userInfo.domain;
      this.fetchPage(true);
    },
    onLimpiar: function onLimpiar() {
      this.onCleanSearch();
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    hasPermission: function hasPermission() {
      var roles = UI_CUSTOM_PERMISIONS['SYNC_TABLE']['roles'];
      var status = false;
      var _iterator2 = _createForOfIteratorHelper(roles),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var rol = _step2.value;
          if (utils.hasRole(rol)) {
            status = true;
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return status;
    },
    toLower: function toLower(value) {
      if (value) return value.toLowerCase();
      return value;
    },
    asyncTableWithSchema: function asyncTableWithSchema(item) {
      var _this2 = this;
      var rowData = utils.cloneJSON(item);
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table,
        source: this.source
      };
      //appApis
      //  .syncTableSchema(params)
      assignments_service.syncTableSchema(params).then(function (response) {
        if (response.code === 200) {
          var message = response.message;
          tasks.toast.success(message);
          //this.$toast.success(message)
          item.columns_change = false;
          var index = _this2.queryResponse.tables.indexOf(item);
          if (index != -1) {
            console.log(index);
            _this2.queryResponse.tables[index].columns_change = false;
            _this2.$set(_this2.queryResponse.tables[index], 'columns_change', false);
            _this2.$refs['my-tables-operator'].$forceUpdate();
          }
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    generateViewUrl: function generateViewUrl(row) {
      console.log("row:", row);
      console.log("row.tableReference:", row.tableReference);
      var _row$tableReference = row.tableReference,
        tableId = _row$tableReference.tableId,
        datasetId = _row$tableReference.datasetId,
        projectId = _row$tableReference.projectId;
      var id = "".concat(projectId, ".").concat(datasetId, ".").concat(tableId);
      console.log("this.listAccessTables:", this.listAccessTables);
      if (this.listAccessTables[id]) {
        window.open(this.listAccessTables[id].viewUrl, '_blank');
      } else {
        tasks.toast.error(this.traductor('frases.no_tables'));
        //this.$toast.warning(this.traductor('frases.no_tables'))
      }
    },
    goLink: function goLink(event, data) {
      event.preventDefault();
      this.$router.push({
        path: "/metadata/detail/".concat(data.item.tagTemplateId)
      });
      return true;
    },
    sendToFilter: function sendToFilter(q) {
      this.filter = q;
      return true;
    },
    sendToSearch: function sendToSearch(q, domain, allDomains) {
      var conditions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var source = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "bigquery";
      this.Q_DEFAULT = TAG_QUERIES.MY_TABLES.replace('${email}', window.userInfo.email);
      this.Q_DEFAULT = "".concat(this.Q_DEFAULT, " ").concat(q);
      var params = {
        query: this.Q_DEFAULT,
        domain: domain,
        allDomains: allDomains,
        conditions: conditions,
        source: this.source ? this.source : "bigquery"
      };
      this.isNewQuery = true;
      this.reloadList(params); // reload list
    },
    openAllTempOwner: function openAllTempOwner() {
      //this.$bvModal.show(this.MODAL_NAME_ALL_OWNER)
      this.$refs[this.MODAL_NAME_ALL_OWNER].onOpen();
      return true;
    },
    openTempOwner: function openTempOwner(item) {
      var _this3 = this;
      this.tplToUpdate = utils.cloneJSON(item);
      var rowData = utils.cloneJSON(item);

      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: userLogin.email,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table,
        source: rowData.source ? rowData.source : "bigquery"
      };
      // get template fields
      //appApis
      //  .listTagEntry(params)
      assignments_service.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          _this3.tplToUpdate = response.data;
          _this3.tplToUpdate.item = rowData;
          //this.$bvModal.show(this.MODAL_NAME_OWNER)
          _this3.$refs[_this3.MODAL_NAME_OWNER].onOpen();
        }
      }).catch(function (e) {
        utils.printError(e);
        //this.openTempOwner(item)
      });
      // this.itemOpen = item
      return true;
    },
    assignOwner: function assignOwner() {
      //this.$bvModal.hide(this.MODAL_NAME_OWNER)
      this.$refs[this.MODAL_NAME_OWNER].onClose();
      console.log("source terminado:", this.source);
      this.reloadList({
        "source": this.source ? this.source : "bigquery"
      });
      return true;
    },
    assignAllOwner: function assignAllOwner() {
      //this.$bvModal.hide(this.MODAL_NAME_ALL_OWNER)
      this.$refs[this.MODAL_NAME_ALL_OWNER].onClose();
      console.log("source terminado:", this.source);
      this.reloadList({
        "source": this.source ? this.source : "bigquery"
      });
      return true;
    },
    openEditTpl: function openEditTpl(item, modalName) {
      var _this4 = this;
      // properties: item, index, event
      var i;
      var rowData = utils.cloneJSON(item);
      console.log("rowdata:", rowData);
      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;

      // For VIEWER_ONLY mode, use separate endpoint for table metadata
      if (modalName === this.MODAL_NAME_METADATA_VIEW) {
        return this.openViewTpl(item, modalName, rowData);
      }
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: userLogin.email,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table,
        source: rowData.source ? rowData.source : "bigquery",
        projectId: rowData.tableReference.projectId,
        datasetId: rowData.tableReference.datasetId,
        tableId: rowData.tableReference.tableId
      };
      // get template fields
      //appApis
      //  .listTagEntry(params)
      assignments_service.getListTagEntry(params).then(function (response) {
        if (response && response.code === 200) {
          var responseTPL = response.data;
          for (i = 0; i < responseTPL.objects.tags.length; i++) {
            if (!responseTPL.objects.tags[i].fields.business_term) {
              if (responseTPL.objects.tags[i].column) {
                responseTPL.objects.tags[i].fields.business_term = {};
                responseTPL.objects.tags[i].fields.business_term.displayName = 'Business Term';
                responseTPL.objects.tags[i].fields.business_term.stringValue = '';
              }
            }
          }
          _this4.tplToUpdate = responseTPL;
          _this4.tplToUpdate.item = rowData;
          _this4.tplToUpdate.tipo = 'edicion';
          _this4.tplToUpdate.origin = 'mytables';
          //this.$bvModal.show(modalName)
          _this4.$refs[modalName].onOpen();
        } else {
          _this4.reloadList();
        }
      }).catch(function (e) {
        utils.printError(e);
        //this.openEditTpl(item, modalName)
      });
      return true;
    },
    openViewTpl: function openViewTpl(item, modalName, rowData) {
      var _this5 = this;
      //VIEWER_ONLY mode - use getListTagEntry

      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: userLogin.email,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table,
        source: rowData.source ? rowData.source : "bigquery",
        projectId: rowData.tableReference.projectId,
        datasetId: rowData.tableReference.datasetId,
        tableId: rowData.tableReference.tableId
      };
      assignments_service.getListTagEntry(params).then(function (response) {
        if (response && response.code === 200) {
          var responseTPL = response.data;
          for (var i = 0; i < responseTPL.objects.tags.length; i++) {
            if (!responseTPL.objects.tags[i].fields.business_term) {
              if (responseTPL.objects.tags[i].column) {
                responseTPL.objects.tags[i].fields.business_term = {};
                responseTPL.objects.tags[i].fields.business_term.displayName = 'Business Term';
                responseTPL.objects.tags[i].fields.business_term.stringValue = '';
              }
            }
          }
          _this5.tplToUpdate = responseTPL;
          _this5.tplToUpdate.item = rowData;
          _this5.tplToUpdate.tipo = 'edicion';
          _this5.tplToUpdate.origin = 'mytables';
          _this5.$refs[modalName].onOpen();
        }
      }).catch(function (e) {
        utils.printError(e);
      });
      return true;
    },
    saveTags: function saveTags() {
      //this.$bvModal.hide(this.MODAL_NAME_METADATA)
      this.$refs[this.MODAL_NAME_METADATA].onClose();
      this.reloadList({
        "source": this.source ? this.source : "bigquery"
      });
      return true;
    },
    processAccessTables: function processAccessTables(tables) {
      var newTables = {};
      if (tables) {
        tables.sort(function (a, b) {
          return a.creationTime - b.creationTime;
        }).reverse().map(function (t) {
          var _t$Table = t.Table,
            objectId = _t$Table.objectId,
            datasetId = _t$Table.datasetId,
            projectId = _t$Table.projectId;
          var id = "".concat(projectId, ".").concat(datasetId, ".").concat(objectId);
          if (newTables[id] === undefined) {
            var v_tableId = t.View.objectId;
            var v_datasetId = t.View.datasetId;
            var v_projectId = t.View.projectId;
            var url = "https://console.cloud.google.com/bigquery?p=".concat(v_projectId, "&d=").concat(v_datasetId, "&page=table&t=").concat(v_tableId, "&project=").concat(v_projectId, "&authuser=1");
            newTables[id] = _objectSpread(_objectSpread({}, t.View), {}, {
              viewUrl: url,
              creationTime: t.creationTime,
              permissionExpirationDate: t.permissionExpirationDate
            });
          }
        });
      }
      this.listAccessTables = newTables;
    },
    changePage: function changePage(page) {
      this.pagination.current = page;
      this.fetchPage();
    },
    getTagsTables: function getTagsTables(tables) {
      var _this6 = this;
      var params = {
        tables: tables,
        source: this.source
      };
      tables_service.getTags(params).then(function (response) {
        _this6.loading_tags = false;
        if (response.data) {
          _this6.queryResponse.tables.forEach(function (item) {
            response.data.forEach(function (x) {
              if (item.relativeResourceName == x.relativeResourceName) {
                item['tags'] = x['tags'];
                x['tags'].forEach(function (tag) {
                  if (tag.templateDisplayName == 'tpl_tables') {
                    item['defaultFields'] = tag;
                  }
                });
              }
            });
          });
          console.log("query", _this6.queryResponse);
          tasks.combineTagsInRows(_this6.queryResponse);
          if (_this6.loading_tags == false && _this6.loading_schema == false) {
            _this6.verifyColumnsWithoutTags();
          }
          _this6.key_table += 1;
        }
      }, function (err) {
        _this6.loading_tags = false;
      });
    },
    getDetailsTables: function getDetailsTables(_tables) {
      var _this7 = this;
      var tables = [];
      this.queryResponse.tables.forEach(function (item) {
        tables.push({
          projectId: item.tableReference.projectId,
          datasetId: item.tableReference.datasetId,
          tableId: item.tableReference.tableId,
          domain_table: item.domain_table,
          source: item.source ? item.source : "bigquery"
        });
      });
      var params = {
        'tables': tables
      };
      assignments_service.getTablesDetails(params).then(function (response2) {
        _this7.loading_schema = false;
        console.log(response2);
        if (response2.data) {
          var _loop = function _loop(key) {
            var items = _this7.queryResponse.tables.filter(function (x) {
              return x.id == response2.data[key].id;
            });
            items.forEach(function (y) {
              y['schema'] = response2.data[key]['schema'];
              y['numRows'] = response2.data[key]['numRows'];
              y['creationTime'] = response2.data[key]['creationTime'];
              y['partition'] = response2.data[key]['timePartitioning'] ? response2.data[key]['timePartitioning']["field"] : null;
            });
          };
          for (var key in response2.data) {
            _loop(key);
          }
          if (_this7.loading_tags == false && _this7.loading_schema == false) {
            _this7.verifyColumnsWithoutTags();
          }
          _this7.key_table += 1;
        }
      }, function (err) {
        _this7.loading_schema = false;
      });
    },
    processParams: function processParams(params) {
      var _ref = params || {},
        _ref$email = _ref.email,
        email = _ref$email === void 0 ? window.userInfo.email : _ref$email,
        _ref$domain = _ref.domain,
        domain = _ref$domain === void 0 ? this.defaultDomain || window.userInfo.domain : _ref$domain,
        _ref$query = _ref.query,
        query = _ref$query === void 0 ? this.Q_DEFAULT || '' : _ref$query,
        _ref$pageSize = _ref.pageSize,
        pageSize = _ref$pageSize === void 0 ? this.pagination.limit : _ref$pageSize,
        _ref$searchWithTags = _ref.searchWithTags,
        searchWithTags = _ref$searchWithTags === void 0 ? true : _ref$searchWithTags,
        _ref$allDomains = _ref.allDomains,
        allDomains = _ref$allDomains === void 0 ? this.defaultDomain == ALL_TABLES_OPTION : _ref$allDomains,
        _ref$approval_flow = _ref.approval_flow,
        approval_flow = _ref$approval_flow === void 0 ? this.approvalFlow : _ref$approval_flow,
        _ref$nextToken = _ref.nextToken,
        nextToken = _ref$nextToken === void 0 ? undefined : _ref$nextToken,
        _ref$conditions = _ref.conditions,
        conditions = _ref$conditions === void 0 ? undefined : _ref$conditions,
        _ref$getAccessTables = _ref.getAccessTables,
        getAccessTables = _ref$getAccessTables === void 0 ? true : _ref$getAccessTables,
        _ref$source = _ref.source,
        source = _ref$source === void 0 ? "bigquery" : _ref$source;
      this.paramsSearch = nextToken === undefined ? {
        email: email,
        domain: domain,
        query: query,
        pageSize: pageSize,
        searchWithTags: searchWithTags,
        allDomains: allDomains,
        approval_flow: approval_flow,
        nextToken: nextToken,
        conditions: conditions,
        getAccessTables: getAccessTables,
        source: source
      } : _objectSpread(_objectSpread({}, this.paramsSearch), {}, {
        nextToken: nextToken
      });
      return this.paramsSearch;
    },
    fetchPage: function fetchPage() {
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (reset) {
        this.pagination.current = 1;
        this.pagination.cursors = [null];
        this.key_pagination += 1;
      }
      var cursor = this.pagination.cursors[this.pagination.current - 1];
      this.nextToken = cursor || {};
      this.Q_DEFAULT = TAG_QUERIES.MY_TABLES.replace('${email}', window.userInfo.email);
      if (this.filter) this.Q_DEFAULT = "".concat(this.Q_DEFAULT, " ").concat(this.filter);
      this.reloadList();
    },
    reloadList: function reloadList(params) {
      var _this8 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var defaultParams = this.processParams(params);
      if (this.approvalFlow) {
        defaultParams['paginationObj'] = this.paginationObj;
      }
      defaultParams['nextToken'] = this.nextToken;
      defaultParams['projects'] = this.projects;
      defaultParams['catalogs'] = this.catalogs;
      this.loadingPage = true;
      var self = this;
      var request = my_access_service.getMyTables(defaultParams);
      request.then(function (response) {
        if (response && response.code === 200) {
          var nextPageToken = response.data.next_page_token;
          if (nextPageToken && Object.keys(nextPageToken).length > 0) {
            // guardar cursor de la siguiente página si no existe aún
            if (!_this8.pagination.cursors[_this8.pagination.current]) {
              _this8.pagination.cursors.push(nextPageToken);
            }
            _this8.pagination.next = true;
          } else {
            _this8.pagination.next = false;
          }
          // We don't know the exact total, we rely on pagination.next
          _this8.pagination.total = -1;
          self.queryResponse = {
            tables: response.data && Array.isArray(response.data.tables) ? response.data.tables : []
          };
          self.getTagsTables(self.queryResponse.tables);
          self.getDetailsTables(self.queryResponse.tables);
          self.messageEmptyList = !response.data.tables.length ? _this8.no_tables : null;
          if (_this8.approvalFlow) {
            _this8.paginationObj = response.data.pagination;
          }
        } else if (response && response.code === 400) {
          console.log(response.code, response.message);
        }
        _this8.isNewQuery = false;
        callback && callback(response);
      }).catch(function (e) {
        utils.printError(e);
        self.messageEmptyList = 'The request was interrupted, try again';
      }).finally(function () {
        _this8.loadingPage = false;
      });
    },
    goPaginate: function goPaginate(type) {
      switch (type) {
        case 'FIRST':
          this.paginationObj.offset = 0;
          break;
        case 'NEXT':
          this.paginationObj.offset = this.paginationObj.next;
          break;
        case 'PREV':
          this.paginationObj.offset = this.paginationObj.previous;
          break;
      }
      this.reloadList();
    },
    closeExecuteItem: function closeExecuteItem() {
      //this.$bvModal.hide(this.MODAL_CONFIRM_EXECUTE_PROFILING)
      this.$refs[this.MODAL_CONFIRM_EXECUTE_PROFILING].onClose();
    },
    openModal: function openModal(item, modalName) {
      this.tableReference = item;
      this.showModal(modalName);
    },
    showModal: function showModal(modalName) {
      //this.$bvModal.show(modalName)
      this.$refs[modalName].onOpen();
    },
    hideModal: function hideModal(modalName) {
      //this.$bvModal.hide(modalName)
      this.$refs[modalName].onClose();
    },
    viewDetail: function viewDetail(item) {
      this.hideModal(this.MODAL_PROFILING_RULES);
      this.item = item;
      this.showModal(this.MODAL_NAME_PROFILING_VIEW);
    },
    getTableFields: function getTableFields() {
      if (this.approvalFlow) {
        return this.tableFields.filter(function (e) {
          return e.label !== 'Environment';
        });
      }
      return this.tableFields || [];
    },
    verifyColumnsWithoutTags: function verifyColumnsWithoutTags() {
      if (!this.queryResponse || !Array.isArray(this.queryResponse.tables)) return;
      this.queryResponse.tables.forEach(function (item) {
        if (!item.schema || !Array.isArray(item.schema.fields) || !Array.isArray(item.tags)) return;
        var tagDict = {};
        item.tags.forEach(function (tag) {
          if (tag.column && tag.templateDisplayName && tag.templateDisplayName.toLowerCase() === 'tpl_columns') {
            tagDict[tag.column.toLowerCase()] = tag;
          }
        });
        var count = 0;
        item.schema.fields.forEach(function (col) {
          if (tagDict[col.name.toLowerCase()]) count++;
        });
        item.columns_change = count !== item.schema.fields.length;
      });
    },
    classColumnsChange: function classColumnsChange() {
      return function (row) {
        return {
          'font-weight-bold text-danger': row.item.columns_change
        };
      };
    }
  }
};